import React from 'react';
import '../Styles/PhotoGallery.css';
import { Gallery, Item } from 'react-photoswipe-gallery';
import { Row, Col } from 'react-bootstrap';

// ================== Import All Images ==================
import img2501 from '../Assets/GalleryMain/2025/25mbf1.jpg';
import img2502 from '../Assets/GalleryMain/2025/25mbf2.jpg';
import img2503 from '../Assets/GalleryMain/2025/25mbf3.jpg';
import img2504 from '../Assets/GalleryMain/2025/25mbf4.jpg';
import img2505 from '../Assets/GalleryMain/2025/25mbf5.jpg';
import img2506 from '../Assets/GalleryMain/2025/25mbf6.jpg';
import img2507 from '../Assets/GalleryMain/2025/25mbf7.jpg';
import img2508 from '../Assets/GalleryMain/2025/25mbf8.jpg';
import img2509 from '../Assets/GalleryMain/2025/25mbf9.jpg';
import img2510 from '../Assets/GalleryMain/2025/25mbf10.jpg';
import img2511 from '../Assets/GalleryMain/2025/25mbf11.jpg';
import img2512 from '../Assets/GalleryMain/2025/25mbf12.jpg';
import img2513 from '../Assets/GalleryMain/2025/25mbf13.jpg';
import img2514 from '../Assets/GalleryMain/2025/25mbf14.jpg';


// 


import img2401 from '../Assets/GalleryMain/2024/24mbf01.jpg';
import img2404 from '../Assets/GalleryMain/2024/24mbf04.jpg';
import img2405 from '../Assets/GalleryMain/2024/24mbf05.jpg';
import img2406 from '../Assets/GalleryMain/2024/24mbf06.jpg';
import img2407 from '../Assets/GalleryMain/2024/24mbf07.jpg';
import img2408 from '../Assets/GalleryMain/2024/24mbf08.jpg';
import img2409 from '../Assets/GalleryMain/2024/24mbf09.jpg';
import img2410 from '../Assets/GalleryMain/2024/24mbf10.jpg';
import img2411 from '../Assets/GalleryMain/2024/24mbf11.jpg';
import img2413 from '../Assets/GalleryMain/2024/24mbf13.jpg';
import img2414 from '../Assets/GalleryMain/2024/24mbf14.jpg';
import img2415 from '../Assets/GalleryMain/2024/24mbf15.jpg';
import img2416 from '../Assets/GalleryMain/2024/24mbf16.jpg';
import img2417 from '../Assets/GalleryMain/2024/24mbf17.jpg';
import img2418 from '../Assets/GalleryMain/2024/24mbf18.jpg';
import img2419 from '../Assets/GalleryMain/2024/24mbf19.jpg';
import img2420 from '../Assets/GalleryMain/2024/24mbf20.jpg';
import img2421 from '../Assets/GalleryMain/2024/24mbf21.jpg';
import img2422 from '../Assets/GalleryMain/2024/24mbf22.jpg';
import img2423 from '../Assets/GalleryMain/2024/24mbf23.jpg';
import img2424 from '../Assets/GalleryMain/2024/24mbf24.jpg';
import img2425 from '../Assets/GalleryMain/2024/24mbf25.jpg';
import img2426 from '../Assets/GalleryMain/2024/24mbf26.jpg';

import img2301 from '../Assets/GalleryMain/23mbf01.png';
import img2302 from '../Assets/GalleryMain/23mbf02.png';
import img2303 from '../Assets/GalleryMain/23mbf03.png';
import img2304 from '../Assets/GalleryMain/23mbf04.png';
import img2305 from '../Assets/GalleryMain/23mbf05.png';
import img2306 from '../Assets/GalleryMain/23mbf06.png';

import img1 from '../Assets/GalleryMain/22mbf01.png';
import img2 from '../Assets/GalleryMain/22mbf02.png';
import img3 from '../Assets/GalleryMain/22mbf03.png';
import img4 from '../Assets/GalleryMain/22mbf04.png';
import img5 from '../Assets/GalleryMain/22mbf05.png';
import img6 from '../Assets/GalleryMain/22mbf06.png';

import img201 from '../Assets/GalleryMain/20mbf01.png';
import img202 from '../Assets/GalleryMain/20mbf02.png';
import img203 from '../Assets/GalleryMain/20mbf03.png';
import img204 from '../Assets/GalleryMain/20mbf04.png';
import img205 from '../Assets/GalleryMain/20mbf05.png';
import img206 from '../Assets/GalleryMain/20mbf06.png';

import img1901 from '../Assets/GalleryMain/19mbf01.png';
import img1902 from '../Assets/GalleryMain/19mbf02.png';
import img1903 from '../Assets/GalleryMain/19mbf03.png';
import img1904 from '../Assets/GalleryMain/19mbf04.png';
import img1905 from '../Assets/GalleryMain/19mbf05.png';

import img1801 from '../Assets/GalleryMain/18mbf01.png';
import img1802 from '../Assets/GalleryMain/18mbf02.png';
import img1803 from '../Assets/GalleryMain/18mbf03.png';

import img1701 from '../Assets/GalleryMain/17mbf01.png';
import img1702 from '../Assets/GalleryMain/17mbf02.png';
import img1703 from '../Assets/GalleryMain/17mbf03.png';
import img1704 from '../Assets/GalleryMain/17mbf04.png';
import img1705 from '../Assets/GalleryMain/17mbf05.png';

import img1601 from '../Assets/GalleryMain/16mbf01.png';
import img1602 from '../Assets/GalleryMain/16mbf02.png';
import img1603 from '../Assets/GalleryMain/16mbf03.png';

import img1501 from '../Assets/GalleryMain/15mbf01.webp';
import img1502 from '../Assets/GalleryMain/15mbf02.png';
import img1503 from '../Assets/GalleryMain/15mbf03.png';

import img1401 from '../Assets/GalleryMain/14mbf01.webp';
import img1402 from '../Assets/GalleryMain/14mbf02.webp';
import img1403 from '../Assets/GalleryMain/14mbf03.webp';

import img1301 from '../Assets/GalleryMain/13mbf01.webp';
import img1302 from '../Assets/GalleryMain/13mbf02.webp';
import img1303 from '../Assets/GalleryMain/13mbf03.webp';
import img1304 from '../Assets/GalleryMain/13mbf04.webp';

import img1201 from '../Assets/GalleryMain/12mbf01.webp';
import img1202 from '../Assets/GalleryMain/12mbf02.webp';

import img1101 from '../Assets/GalleryMain/11mbf01.webp';
import img1102 from '../Assets/GalleryMain/11mbf02.webp';
import img1103 from '../Assets/GalleryMain/11mbf03.webp';

// ================== Image Data ==================
const galleryData = [
      { year: '2025', images: [img2501, img2502, img2503, img2504, img2505, img2506, img2507, img2508, img2509, img2510, img2511, img2512, img2513, img2514] },
  { year: '2024', images: [img2401, img2404, img2405, img2406, img2407, img2408, img2409, img2410, img2411, img2413, img2414, img2415, img2416, img2417, img2418, img2419, img2420, img2421, img2422, img2423, img2424, img2425, img2426] },
  { year: '2023', images: [img2301, img2302, img2303, img2304, img2305, img2306] },
  { year: '2022', images: [img1, img2, img3, img4, img5, img6] },
  { year: '2020', images: [img201, img202, img203, img204, img205, img206] },
  { year: '2019', images: [img1901, img1902, img1903, img1904, img1905] },
  { year: '2018', images: [img1801, img1802, img1803] },
  { year: '2017', images: [img1701, img1702, img1703, img1704, img1705] },
  { year: '2016', images: [img1601, img1602, img1603] },
  { year: '2015', images: [img1501, img1502, img1503] },
  { year: '2014', images: [img1401, img1402, img1403] },
  { year: '2013', images: [img1301, img1302, img1303, img1304] },
  { year: '2012', images: [img1201, img1202] },
  { year: '2011', images: [img1101, img1102, img1103] }
];

function PhotoGallery() {
  return (
    <div>
      <section className='photogallerySpace'>
        <div>
          <h3
            data-aos="fade-up"
            data-aos-easing="ease-in"
            data-aos-duration="2000"
            className='galleryMainHead'
          >
            PHOTO GALLERY
          </h3>
        </div>
        <Gallery>
          {galleryData.map((yearData, i) => (
            <section
              key={yearData.year}
              className={`gallerySpace ${i > 2 ? 'secondGallerySpace' : ''}`}
            >
              <div>
                <p className='yearTxt'>{yearData.year}</p>
              </div>
              <Row className='spacePhotos'>
                {yearData.images.map((img, idx) => (
                  <Col
                    key={idx}
                    className={`mobileSpacePhotos ${idx > 2 ? 'topspcdsk' : ''}`}
                    sm={12}
                    xs={12}
                    md={12}
                    lg={4}
                    xl={4}
                  >
                    <Item
                      original={img}
                      thumbnail={img}
                      width='1021'
                      height='680'
                    >
                      {({ ref, open }) => (
                        <img
                          data-aos="fade-up"
                          data-aos-duration="1000"
                          ref={ref}
                          onClick={open}
                          alt={`mbf ${yearData.year}`}
                          src={img}
                          className="photogallerythumbnail"
                        />
                      )}
                    </Item>
                  </Col>
                ))}
              </Row>
            </section>
          ))}
        </Gallery>
      </section>
    </div>
  );
}

export default PhotoGallery;
